
import { defineComponent, ref } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import PostSingleViolation from '@/components/Post/PostSingleViolation.vue'
import { SettingsStatus } from '@/model/data-object/Post'

export default defineComponent({
  name: 'PostSingleParent',
  components: { PostSingleViolation, AButton, AIcon },
  props: {
    postRoot: {
      // type: Post, // todo change type to POST
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      truncated: false,
      expanded: false,
    }
  },
  methods: {
    isTruncated() {
      const annotation: any = this.$refs.annotation
      if (typeof annotation === 'undefined') {
        return false
      }

      return (
        annotation.clientWidth < annotation.scrollWidth ||
        annotation.clientHeight < annotation.scrollHeight
      )
    },
    isParentHidden() {
      return [SettingsStatus.HIDDEN, SettingsStatus.GDPR_DELETED].includes(
        this.postRoot.parentPost.status
      )
    },
  },
  watch: {
    annotation(val) {
      if (val) {
        this.truncated = this.isTruncated()
      }
    },
  },
  mounted() {
    this.truncated = this.isTruncated()
  },
  setup() {
    const annotation = ref(null)

    return { annotation }
  },
})
